import { forwardRef, useImperativeHandle, useRef } from 'react';
import {TextField} from '@mui/material';
import styles from './textbox.module.scss';

// eslint-disable-next-line react/display-name
export const EvesTextbox = forwardRef((props: any, ref: any) => {
	const {
		isFilter,
		isRequired,
		helperText,
		error,
		sx,
		InputProps,
		id,
		label,
		type,
		variant,
		fullWidth = true,
		...textFieldProps
	} = props;

	const inputRef: any = useRef(null);

	useImperativeHandle(ref, () => ({
		setFocus: () => {
			inputRef?.current?.focus();
		}
	}));

	return (
		<TextField
			className={`${styles.textbox} ${isFilter ? styles.textboxFilter : ''}`}
			id={id}
			label={label}
			type={type}
			fullWidth={fullWidth}
			required={isRequired}
			variant={variant}
			error={error}
			helperText={helperText}
			InputProps={InputProps}
			inputRef={inputRef}
			autoComplete="off"
			sx={{
				...sx,
				'& .MuiOutlinedInput-root': {
					...(sx?.['& .MuiOutlinedInput-root'] || {}),
				},
				'& .MuiInputLabel-root': {
					...(sx?.['& .MuiInputLabel-root'] || {}),
				},
			}}
			{...textFieldProps}
		/>
	);
});
